/* eslint-disable max-len */
import { MiddlewareAPI } from '@reduxjs/toolkit';
import { Dispatch } from 'react';
import { expireSessionAsync } from './auth/authSlice';

interface AuthActionProps {
  type: string,
  error?: {
    code: string,
  },
}

const authMiddleware = (store: MiddlewareAPI<any>) => (next: Dispatch<any>) => (action: AuthActionProps) => {
  if (
    action.type !== 'auth/logout/rejected'
    && action.type !== 'auth/expire-session/rejected'
    && action.error?.code === '403'
  ) {
    store.dispatch(expireSessionAsync());
  }
  return next(action);
};
export default authMiddleware;

